import React, { useEffect } from 'react'

import PropTypes from 'prop-types'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'
import useCustomTheme from 'hooks/useCustomTheme'

import helpers from 'helpers'

const TrainingDepartmentPdf = ({
  generateDepartment,
  setGenerateDepartment = () => {},
  departmentData = [],
  shouldCreateVersion = false,
  refresh = () => {},
  qrCode = '',
  stats,
}) => {
  const snackbar = useSnackbar()
  const { customTheme, customLogo, customPalette } = useCustomTheme()
  const { userCompany } = useAuth()

  const customStyles = customTheme?.palette?.layout
  const customThemeStatus = customPalette?.status

  useEffect(() => {
    if (generateDepartment && departmentData && departmentData.length > 0) {
      helpers.reports.departments.exportPdf({
        customLogo,
        customStyles,
        customThemeStatus,
        qrCode,
        refresh,
        setGenerateDepartment,
        shouldCreateVersion,
        snackbar,
        userCompany,
        departmentData,
        stats,
      })
      setGenerateDepartment(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateDepartment, setGenerateDepartment, departmentData])

  return <></>
}

TrainingDepartmentPdf.propTypes = {
  setGenerateDepartment: PropTypes.func,
  departmentData: PropTypes.array,
}

export default TrainingDepartmentPdf
